import { render, staticRenderFns } from "./OptionDropdown.vue?vue&type=template&id=625609f2&"
import script from "./OptionDropdown.vue?vue&type=script&lang=js&"
export * from "./OptionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports